import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { EditorHelp } from '../_EditorHelp/_EditorHelp';

import styles from './ThreeThirds.module.css';

export default function ThreeColumns(props: ComponentProps): JSX.Element {
	return (
		<>
			<EditorHelp text="Three Thirds START" indent color={'blue'} />
			<section className={`${styles.grid} pad container maxWidth`}>
				<div>
					<Placeholder name="rcnlearn-thirdone" rendering={props.rendering} />
				</div>
				<div>
					<Placeholder name="rcnlearn-thirdtwo" rendering={props.rendering} />
				</div>
				<div>
					<Placeholder name="rcnlearn-thirdthree" rendering={props.rendering} />
				</div>
			</section>
			<EditorHelp text="Three Thirds END" indent color={'blue'} />
		</>
	);
}
